import React from 'react';

import { LinkProps } from 'next/link';
import { ContainerNavLink } from './styles';
import { ActiveLink } from '../ActiveLink';

type NavLinkProps = LinkProps & {
  text: string;
  href: string;
};

export function NavLink({ text, href }: NavLinkProps) {
  return (
    <ActiveLink href={href} passHref shouldMatchExactHref>
      <ContainerNavLink>
        <span>{text}</span>
      </ContainerNavLink>
    </ActiveLink>
  );
}
